<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Explore',
	showTitle: 'true',
	links: [{ name: 'All Topics', link: '/topics' }],
}
const schema = defineSchema({
	title: $.text('Title'),
	showTitle: $.select('Show Title', [
		{ label: 'Yes', value: 'true' },
		{ label: 'No', value: 'false' },
	]),
	links: $.array('Links', defineSchema({
		name: $.text('Name'),
		link: $.text('Link'),
	}), { collapsible: true }),
})
export const BlockTopLinks = defineBlock({ thumbnail: '/block-thumbs/BlockTopLinks.svg', category: 'Content', order: 290, name: 'BlockTopLinks', label: 'Top Links', icon: 'link', schema, defaults })
</script>
<script setup lang="ts">


interface TopLink {
	name: string
	link: string
}

defineProps<{
	title?: string
	showTitle?: string
	links?: TopLink[]
}>()
</script>

<template>
	<div class="txt-center w1100px pb-1">
		<span v-if="showTitle !== 'false' && title" class="px-05 py-025 bold">
			{{ title }}
		</span>
		<router-link
			v-for="link in links"
			:key="link.link"
			:to="link.link"
			class="decoration-none px-05 py-025 light redUnderline"
		>
			<i>
				{{ link.name }}
			</i>
		</router-link>
	</div>
</template>

<style scoped>

</style>
